import { api } from '../api'

import type { ApiTableEditPlayer } from '@acepoker/contract'

export const updatePlayer = async (data: ApiTableEditPlayer): Promise<{ code: number }> =>
  await api().url('/api/table/player').put(data).json()
